// extracted by mini-css-extract-plugin
module.exports = {"label":"_1TTlyxvnOAnlR2fgXs7KOP","active":"_3GakbCjHdzBuc_CNTwb-mC"};